<template>
	<div class="destinations">
		<label
			v-for="(location,index) in fromLocations"
			:key="`from${index}`"
			:class="{active: index > fromIndex, start: index === fromIndex}"
			class="location-from"
		>
			<input
				:checked="fromIndex === index"
				:value="index"
				name="fromLocation"
				type="radio"
				class="input"
				@change="changeFromLocation(index)"
			>
			<div class="location-dot" />

			<div class="destinations-from-content">
				<t-details-item
					v-if="location.select"
					:label="location.label"
					:labelClass="location.labelClass"
				>
					<template v-slot:primary>
						<slot name="customFromDetails" :location="location" :index="index" />
					</template>
				</t-details-item>
				<t-details-item
					v-else
					:label="location.label"
					:primary="location.name"
					:labelClass="location.labelClass"
					:primaryClass="location.primaryClass"
				/>
			</div>
		</label>
		<label
			v-if="allowCustomFrom"
			:key="`from${fromLocations.length}`"
			:class="{active: fromLocations.length > fromIndex, start: fromLocations.length === fromIndex}"
			class="location-from"
		>
			<input
				:checked="fromIndex === fromLocations.length"
				:value="fromLocations.length"
				name="fromLocation"
				type="radio"
				class="input"
				@change="changeFromLocation(fromLocations.length)"
			>
			<div class="location-dot" />

			<div class="destinations-from-content">
				<slot name="customFrom" />
			</div>
		</label>

		<label
			v-if="allowCustomTo"
			:key="`to${toLocations.length}`"
			:class="{active: true, end: toLocations.length === toIndex}"
			class="location-to"
		>
			<input
				:checked="toIndex === toLocations.length"
				:value="toLocations.length"
				name="toLocation"
				type="radio"
				class="input"
				@change="changeToLocation(toLocations.length)"
			>
			<div class="location-dot" />

			<div class="destinations-to-content">
				<slot name="customTo" />
			</div>
		</label>

		<label
			v-for="(location,index) in toLocations"
			:key="`to${index}`"
			:class="{active: (index < toIndex && toIndex !== toLocations.length), end: index === toIndex}"
			class="location-to"
		>
			<input
				:checked="toIndex === index"
				:value="index"
				name="toLocation"
				type="radio"
				class="input"
				@change="changeToLocation(index)"
			>
			<div class="location-dot" />
			<div class="destinations-to-content">
				<t-details-item
					v-if="location.select"
					:label="location.label"
					:labelClass="location.labelClass"
				>
					<template v-slot:primary>
						<slot name="customToDetails" :location="location" :index="index" />
					</template>
				</t-details-item>
				<t-details-item
					v-else
					:label="location.label"
					:primary="location.name"
					:labelClass="location.labelClass"
					:primaryClass="location.primaryClass"
				/>
			</div>
		</label>
		
	</div>
</template>

<script>
export default {
	name: 'TStretchSelect',
	props: {
		fromLocations: Array,
		toLocations: Array,
		fromIndex: {
			type: Number,
			default: 0
		},
		toIndex: {
			type: Number,
			default: 0
		},
		allowCustomFrom: Boolean,
		allowCustomTo: Boolean
	},
	methods: {
		changeFromLocation(value) {
			this.$emit('changeFromLocation', value);
		},
		changeToLocation(value) {
			this.$emit('changeToLocation', value);
		},
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

.input {
	border: 0px;
	clip: rect(1px, 1px, 1px, 1px);
	height: 1px;
	overflow: hidden;
	padding: 0px;
	position: absolute;
	white-space: nowrap;
	width: 1px;
	opacity: 0;
	&:checked + .location-dot {
		background-color: get-color($blue-scale, 'B9');
	}
	&:disabled + .location-dot {
		background-color: get-color($neutral-scale, 'N4');
	}
	&:disabled:checked + .location-dot {
		background-color: get-color($neutral-scale, 'N9');
	}
}
.location-dot {
	background-color: get-color($neutral-scale, 'N4');
	border-radius: 10px;
	width: 16px;
	height: 16px;
	padding: 2px;
	box-sizing: border-box;
	position:relative;
	z-index: 1;
}

@mixin line($color, $size, $direction, $height) {
	content: '';
	position: absolute;
	width: #{$size}px;
	background-color: $color;
	height: $height;
	$half: $size / 2;
	$center: 6px;
	left: $center;
	@if $direction == 'up' {
		top: 0;
	} @else {
		bottom: 0;
	}
}

.destinations {
	display: grid;
	column-gap: 20px;
	align-items: center;

	.location-from, .location-to {
		display: grid;
		column-gap: 20px;
		grid-template-columns: 20px auto;
		grid-template-rows: repeat(2, minmax(min-content, max-content));
		align-items: center;
		position: relative;
		margin-bottom: 0;
	}

	.location-from{
		padding-bottom: 15px;
		&:before {
			@include line(get-color($neutral-scale, 'N4'), 4, 'down', 100%);
		}
		&:first-child:before {
			@include line(get-color($neutral-scale, 'N4'), 4, 'down', 50%);
		}
		&.active:after {
			@include line(get-color($blue-scale, 'B9'), 4, 'down', 100%);
		}
		&.start:after {
			@include line(get-color($blue-scale, 'B9'), 4, 'down', 50%);
		}
	}
	.location-to {
		padding-top: 15px;
		&:before {
			@include line(get-color($neutral-scale, 'N4'), 4, 'up', 100%);
		}
		&:last-child:before {
			@include line(get-color($neutral-scale, 'N4'), 4, 'up', 50%);
		}
		&.active:after {
			@include line(get-color($blue-scale, 'B9'), 4, 'up', 100%);
		}
		&.end:after {
			@include line(get-color($blue-scale, 'B9'), 4, 'up', 50%);
		}
	}
}

</style>
<docs>
```jsx
new Vue({
	data(){
		return {
			from: [
				{label: 'Trip Start', name: 'Terminal Tiller', labelClass: "labelClass", primaryClass: "primarylClass" },
				{label: 'Pickup Location', name: 'Autorep Heimdal', labelClass: "labelClass", primaryClass: "primarylClass" }
			],
			to: [
				{label: 'Trip End', name: 'Terminal Ålesund', labelClass: "labelClass", primaryClass: "primarylClass" },
				{label: 'Delivery Location', name: 'Mekonomen Namsos', labelClass: "labelClass", primaryClass: "primarylClass" }
			],
		}
	},
	template: `
		<div style="width:500px">
			<t-stretch-select
				:from="from"
				:to="tp"
			/>
		</div>`
});
```
</docs>